import request, { IServerResponse } from '@/utils/request';
import { ICategoryItem, IDelServiceReq, IOnlineServiceReq } from './define';

export const getServiceList = (): Promise<IServerResponse<ICategoryItem[]>> =>
    request.get('/api/service/list');

export const onlineService = (param: IOnlineServiceReq): Promise<IServerResponse<null>> =>
    request.post('/api/service/changeStatus', param);

export const delService = (param: IDelServiceReq): Promise<IServerResponse<null>> =>
    request.post('/api/service/delete', param);

export const getCopyUrl = (params: { itemId: number }): Promise<IServerResponse<string>> =>
    request.post('/api/service/share', params);
